import React from "react";
import UpdatesWidget from "./UpdatesWidget"; // Assuming the UpdatesWidget component is imported
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
const MainSection = () => {
  return (
    <Row>
      <Col xl={1}></Col>
      <Col xl={8} xs={12}>
        <article className="text-left text-base text-white py-8">
          <main
            style={{ maxWidth: "90%", width: "90%" }}
            className="mx-auto px-2 grid-layout"
          >
            {/* Main Content */}
            <section className="main-content">
            <div className="mb-8 bg-black px-1 py-1  items-center justify-between" style={{color:"#eab30b" }}>
                <h3 className="items-center justify-between">
                  Latest in the Series
                </h3>
                
              </div>
                            <div className="mb-8 flex flex-col lg:flex-row items-start">
                <div className="flex-grow lg:pr-8">
                  <a href="https://illinoisanswers.org/2026/04/07/travis-braden-restraint-chairs-williamson-county-jail/">
                    <h2 className="text-2xl font-bold">
                    Mentally ill man restrained in chair for 3 days settles case in Williamson County
                   </h2>
                    <p className="text-gray-400 mb-4">
                    Travis Braden settled his civil rights case with Williamson County for $27,500 after he was restrained in a chair for days — a practice deemed “torture” by the United Nations.
                    </p>
                    <p className="text-gray-400 mb-4"> April 7, 2026</p>
                    <span>by Grace Hauck
                    </span>
                  </a>
                </div>
                <div className="flex-shrink-0">
                  <a href="https://illinoisanswers.org/2026/04/07/travis-braden-restraint-chairs-williamson-county-jail/">
                    <img
                      src="https://i0.wp.com/illinoisanswers.org/wp-content/uploads/2024/10/B0011725-1-scaled.jpg?fit=2000%2C1499&quality=89&ssl=1"
                      alt="Story 2"
                      className="max-w-xl w-full"
                    />
                  </a>
                </div>
              </div>
              <div className="mb-8 bg-yellow-500 text-black items-center justify-between">
                <h3 className="items-center justify-between">
                Read All the Stories                </h3>
              </div>
              <div className="mb-8 flex flex-col lg:flex-row items-start">
                <div className="flex-grow lg:pr-8">
                  <a href="https://illinoisanswers.org/2024/07/09/the-u-n-calls-restraint-chairs-torture-illinois-jails-use-them-every-day/">
                    <h2 className="text-2xl mb-1 font-bold">
                      The U.N. Calls Restraint Chairs Torture. Illinois Jails
                      Use Them Every Day.
                    </h2>
                    <p className="text-gray-400 mb-4">
                      The Illinois Answers Project found jail staff are
                      restraining people in chairs in ways that often violate
                      policies and last longer than recommended by
                      manufacturers.
                    </p>
                    <p className="text-gray-400 mb-4">July 9, 2024</p>
                    <span> By Grace Hauck</span>
                  </a>
                </div>
                <div className="flex-shrink-0">
                  <a href="https://illinoisanswers.org/2024/07/09/the-u-n-calls-restraint-chairs-torture-illinois-jails-use-them-every-day/">
                    <img
                      src="https://i0.wp.com/illinoisanswers.org/wp-content/uploads/2024/05/B0011735-scaled.jpg?resize=2000%2C1499&ssl=1"
                      alt="Story 1"
                      className="max-w-xl w-full"
                    />
                  </a>
                </div>
              </div>
              <hr className="my-8"></hr>
              <div className="mb-8 flex flex-col lg:flex-row items-start">
                <div className="flex-grow lg:pr-8">
                  <a href="https://illinoisanswers.org/2024/07/16/most-illinois-jails-restrain-people-in-chairs-this-county-violently-shocked-them-too/">
                    <h2 className="text-2xl font-bold">
                      Most Illinois jails restrain people in chairs. This county
                      ‘violently shocked’ them, too.
                    </h2>
                    <p className="text-gray-400 mb-4">
                      A few years ago, Coles County Jail promised to stop using
                      electrified “stun cuffs” to shock people restrained in
                      chairs. How much has changed?
                    </p>
                    <p className="text-gray-400 mb-4"> July 16, 2024</p>
                    <span>By Grace Hauck</span>
                  </a>
                </div>
                <div className="flex-shrink-0">
                  <a href="https://illinoisanswers.org/2024/07/16/most-illinois-jails-restrain-people-in-chairs-this-county-violently-shocked-them-too/">
                    <img
                      src="https://illinoisanswers.org/wp-content/uploads/2024/06/B0011948.jpg"
                      alt="Story 2"
                      className="max-w-xl w-full"
                    />
                  </a>
                </div>
              </div>

              <hr className="my-8"></hr>
              <div className="mb-8 flex flex-col lg:flex-row items-start">
                <div className="flex-grow lg:pr-8">
                  <a href="https://illinoisanswers.org/2024/10/15/franklin-county-jail-illinois-restrained-mentally-ill-men-in-chairs/">
                    <h2 className="text-2xl font-bold">
                      A mentally ill man was restrained in a chair for 68 hours
                      at Franklin County Jail, violating policies, report says.
                    </h2>
                    <p className="text-gray-400 mb-4">
                      One man was restrained for 68 hours, another for 27 hours.
                      Both were mentally ill. The jail’s own policies say
                      restraint should never last more than 10 hours.
                    </p>
                    <p className="text-gray-400 mb-4"> October 15, 2024</p>
                    <span>By Grace Hauck</span>
                  </a>
                </div>
                <div className="flex-shrink-0">
                  <a href="https://illinoisanswers.org/2024/10/15/franklin-county-jail-illinois-restrained-mentally-ill-men-in-chairs/">
                    <img
                      src="https://i0.wp.com/illinoisanswers.org/wp-content/uploads/2024/10/Franklin-County-Jail-google-earth-2-scaled.jpg?"
                      alt="Story 2"
                      className="max-w-xl w-full"
                    />
                  </a>
                </div>
              </div>
              <hr className="my-8"></hr>
              <div className="mb-8 flex flex-col lg:flex-row items-start">
                <div className="flex-grow lg:pr-8">
                  <a href="https://illinoisanswers.org/2024/10/28/peoria-jail-restrained-mental-illness-five-days/'">
                    <h2 className="text-2xl font-bold">
                      He attempted suicide. Peoria Jail restrained him in a
                      chair for five days.
                    </h2>
                    <p className="text-gray-400 mb-4">
                      Peoria County Jail, in recent years, has restrained its
                      charges for longer durations than other jails in Illinois
                      and far past industry recommendations. There is evidence
                      of a mental health issue in at least 70% of its restraint
                      incidents.
                    </p>
                    <p className="text-gray-400 mb-4"> October 28, 2024</p>
                    <span>By Meredith Newman</span>
                  </a>
                </div>
                <div className="flex-shrink-0">
                  <a href="https://illinoisanswers.org/2024/10/28/peoria-jail-restrained-mental-illness-five-days/">
                    <img
                      src="https://i0.wp.com/illinoisanswers.org/wp-content/uploads/2024/10/collage-3.png?fit=1200%2C800&ssl=1"
                      alt="Story 2"
                      className="max-w-xl w-full"
                    />
                  </a>
                </div>
              </div>
              <hr className="my-8"></hr>
              <div className="mb-8 flex flex-col lg:flex-row items-start">
                <div className="flex-grow lg:pr-8">
                  <a href="https://illinoisanswers.org/2024/12/17/our-strapped-down-series-on-restraint-chairs-in-illinois-is-now-a-zine/">
                    <h2 className="text-2xl font-bold">
                      Our “Strapped Down” series on restraint chairs in Illinois
                      is now a zine
                    </h2>
                    <p className="text-gray-400 mb-4">
                      We spent months looking into the use of restraint chairs
                      in Illinois. You can now read about our findings and more
                      resources in our zine.
                    </p>
                    <p className="text-gray-400 mb-4"> December 19, 2024</p>
                    <span>By Illinois Answers Project</span>
                  </a>
                </div>
                <div className="flex-shrink-0">
                  <a href="https://illinoisanswers.org/2024/12/17/our-strapped-down-series-on-restraint-chairs-in-illinois-is-now-a-zine/">
                    <img
                      src="https://i0.wp.com/illinoisanswers.org/wp-content/uploads/2024/12/Group-130.png?w=1200&ssl=1"
                      alt="Story 2"
                      className="max-w-xl w-full"
                    />
                  </a>
                </div>
              </div>

              <hr className="my-8"></hr>
              <div className="mb-8 flex flex-col lg:flex-row items-start">
                <div className="flex-grow lg:pr-8">
                  <a href="https://illinoisanswers.org/2025/01/29/illinois-jail-restrained-mentally-ill-madison-county/">
                    <h2 className="text-2xl font-bold">
                    People were strapped to chairs for hours, days at Madison County Jail. Many were mentally ill or in withdrawal.
                    </h2>
                    <p className="text-gray-400 mb-4">
                    Of all Illinois jails, Madison County has the most incidents of restraint lasting longer than 10 hours–the upper limit set by the chair manufacturer. The jail said they’re not equipped to care for so many mentally ill detainees.
                    </p>
                    <p className="text-gray-400 mb-4"> January 29, 2025</p>
                    <span>by Grace Hauck <br/> and Janelle O'Dea
                    </span>
                  </a>
                </div>
                <div className="flex-shrink-0">
                  <a href="https://illinoisanswers.org/2025/01/29/illinois-jail-restrained-mentally-ill-madison-county/">
                    <img
                      src="https://illinoisanswers.org/wp-content/uploads/2025/01/Hidalgo-Restraint-Chair-12192024-03-scaled.jpg"
                      alt="Story 2"
                      className="max-w-xl w-full"
                    />
                  </a>
                </div>
              </div>
              <hr className="my-8"></hr>
              <div className="mb-8 flex flex-col lg:flex-row items-start">
                <div className="flex-grow lg:pr-8">
                  <a href="https://illinoisanswers.org/2025/02/08/champaign-jail-updates-restraint-chair-policies/">
                    <h2 className="text-2xl font-bold">
                    Champaign County Jail Begins Tracking and Reporting Use of Restraint Chairs to the State for the First Time
                    </h2>
                    <p className="text-gray-400 mb-4">
                    Champaign County Jail updated the way it documents, tracks and reports use of restraint chairs after an Illinois Answers Project investigation raised questions about the facility’s record-keeping practices and failure to report incidents to a state oversight unit.
                    </p>
                    <p className="text-gray-400 mb-4"> February 8, 2025</p>
                    <span>by Grace Hauck
                    </span>
                  </a>
                </div>
                <div className="flex-shrink-0">
                  <a href="https://illinoisanswers.org/2025/02/08/champaign-jail-updates-restraint-chair-policies/">
                    <img
                      src="https://illinoisanswers.org/wp-content/uploads/2025/02/Champaign-restraint-chair-3-scaled.jpg"
                      alt="Story 2"
                      className="max-w-xl w-full"
                    />
                  </a>
                </div>
              </div>
              <hr className="my-8"></hr>
              <div className="mb-8 flex flex-col lg:flex-row items-start">
                <div className="flex-grow lg:pr-8">
                  <a href="https://illinoisanswers.org/2025/04/22/restraint-chairs-unreported-cook-county-jail/">
                    <h2 className="text-2xl font-bold">
                    Cook County Jail restrained people in chairs 874 times — and never reported it to the state                    </h2>
                    <p className="text-gray-400 mb-4">
                    The state requires jails to report when they use restraint chairs. For nearly 900 cases from 2019 to 2023, Cook County Jail never did.                    </p>
                    <p className="text-gray-400 mb-4"> April 22, 2025</p>
                    <span>by Grace Hauck
                    </span>
                  </a>
                </div>
                <div className="flex-shrink-0">
                  <a href="https://illinoisanswers.org/2025/04/22/restraint-chairs-unreported-cook-county-jail/">
                    <img
                      src="https://illinoisanswers.org/wp-content/uploads/2025/04/IMG_4146.jpg"
                      alt="Story 2"
                      className="max-w-xl w-full"
                    />
                  </a>
                </div>
              </div>
              <hr className="my-8"></hr>

              <div className="mb-8 flex flex-col lg:flex-row items-start">
                <div className="flex-grow lg:pr-8">
                  <a href="https://illinoisanswers.org/2025/05/15/how-three-states-address-the-use-and-abuse-of-restraint-chairs/">
                    <h2 className="text-2xl font-bold">
                    How three states are addressing the use and abuse of restraint chairs
                   </h2>
                    <p className="text-gray-400 mb-4">
                    Our “Strapped Down” series investigated the misuse of restraint chairs in Illinois, but the devices are used in jails across the U.S. These stories explore how California, Iowa, and Pennsylvania have responded to misuse in their states.
                    </p>
                    <p className="text-gray-400 mb-4"> May 15, 2025</p>
                    <span>by Grace Hauck
                    </span>
                  </a>
                </div>
                <div className="flex-shrink-0">
                  <a href="https://illinoisanswers.org/2025/05/15/how-three-states-address-the-use-and-abuse-of-restraint-chairs/">
                    <img
                      src="https://illinoisanswers.org/wp-content/uploads/2025/05/IMG_3580-scaled.jpg"
                      alt="Story 2"
                      className="max-w-xl w-full"
                    />
                  </a>
                </div>
              </div>
              <hr className="my-8"></hr>


<div className="mb-8 flex flex-col lg:flex-row items-start">
  <div className="flex-grow lg:pr-8">
    <a href="https://illinoisanswers.org/2025/05/15/video-strapped-down-investigating-restraint-chairs-in-illinois-jails/">
      <h2 className="text-2xl font-bold">
      {'[Video] Strapped Down: Investigating Restraint Chairs in Illinois Jails'}
      </h2>
      <p className="text-gray-400 mb-4">
      Our “Strapped Down” series investigated the misuse of restraint chairs in Illinois, but the devices are used in jails across the U.S. These stories explore how California, Iowa, and Pennsylvania have responded to misuse in their states.
      </p>
      <p className="text-gray-400 mb-4"> May 15, 2025</p>
      <span>by Grace Hauck
      </span>
    </a>
  </div>
  <div className="flex-shrink-0">
    <a href="https://illinoisanswers.org/2025/05/15/video-strapped-down-investigating-restraint-chairs-in-illinois-jails/">
      <img
        src="https://illinoisanswers.org/wp-content/uploads/2024/05/B0011836.jpg"
        alt="Story 2"
        className="max-w-xl w-full"
      />
    </a>
  </div>
</div>
              <hr className="my-8"></hr>

                            <div className="mb-8 flex flex-col lg:flex-row items-start">
                <div className="flex-grow lg:pr-8">
                  <a href="https://illinoisanswers.org/2026/04/07/travis-braden-restraint-chairs-williamson-county-jail/">
                    <h2 className="text-2xl font-bold">
                    Mentally ill man restrained in chair for 3 days settles case in Williamson County
                   </h2>
                    <p className="text-gray-400 mb-4">
                    Travis Braden settled his civil rights case with Williamson County for $27,500 after he was restrained in a chair for days — a practice deemed “torture” by the United Nations.
                    </p>
                    <p className="text-gray-400 mb-4"> April 7, 2026</p>
                    <span>by Grace Hauck
                    </span>
                  </a>
                </div>
                <div className="flex-shrink-0">
                  <a href="https://illinoisanswers.org/2026/04/07/travis-braden-restraint-chairs-williamson-county-jail/">
                    <img
                      src="https://i0.wp.com/illinoisanswers.org/wp-content/uploads/2024/10/B0011725-1-scaled.jpg?fit=2000%2C1499&quality=89&ssl=1"
                      alt="Story 2"
                      className="max-w-xl w-full"
                    />
                  </a>
                </div>
              </div>
              <hr className="my-8"></hr>
            </section>

            {/* Updates Widget */}
          </main>
        </article>
      </Col>
      <Col xl={3} className="px-4">
        {" "}
        <aside className="updates-widget py-8">
          <UpdatesWidget />
        </aside>
      </Col>
    </Row>
  );
};

export default MainSection;

